<template>
  <div class="content">
      <div class="block block-rounded block-fx-shadow mb-3">
        <div class="block-header">
          <h3 class="block-title">{{ $t('debt_tasks.index') }}</h3>
          <div class="block-options">
            <b-btn v-b-modal.adddebt_task size="sm" variant="primary" class="float-right">{{ $t('debt_tasks.add') }}</b-btn>
          </div>
        </div>
        <div class="table-responsive-xl">
          <table class="table table-bordered  table-hover display">
            <thead>
              <tr>
                <th>#</th>
                <th>{{ $t('users.user') }}</th>
                <th>{{ $t('debts.registry_date') }}</th>
                <th>{{ $t('debt_tasks.date') }}</th>
                <th>{{ $t('options.statuses') }}</th>
                <th>{{ $t('contragents.index') }}</th>
                <th>{{ $t('app.action') }}</th>
              </tr>
            </thead>
            <tbody>
                <template v-if="!loadDebtTasks">
                  <tr v-for="(debt_task, index) in debt_tasks" :key="debt_task.id">
                    <td>{{index+1}}</td>
                    <td>{{debt_task.user ? `${debt_task.user.fullname}`: '' }}</td>
                    <td>{{debt_task.registry_date | dateFormat}}</td>
                    <td>с {{debt_task.start_date | datetimeFormat}} до {{debt_task.end_date | datetimeFormat}}</td>
                    <td>
                      <span v-for="status in debt_task.statuses" :key="status.id">
                        {{ status.name }} <br>
                      </span>
                    </td>
                    <td>
                      <span v-for="contragent in debt_task.contragents" :key="contragent.id">
                        {{ contragent.name }} <br>
                      </span>
                    </td>
                    <td>
                      <div class="btn-group" role="group" aria-label="btnGroup1">
                        <button @click.prevent="initUpdate(index)" class="btn btn-primary btn-sm" title="Редактировать">
                          <i class="fa fa-edit"></i>
                        </button>
                        <button @click.prevent="handleDelete(debt_task.id)" class="btn btn-danger btn-sm " :disabled="isProcessing" title="Удалить">
                          <i class="fa fa-times-circle"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </template>

                <tr class="text-center" v-if="loadDebtTasks">
                  <td colspan="8">
                    <loader-wave/>
                  </td>
                </tr>
            </tbody>
          </table>
          <pagination :pagination="pagination" :offset="4" @paginate="fetchDebtTasks()"/>
        </div>
      </div>

      <b-modal
        id="adddebt_task"
        ref="addDebtTask"
        size="lg"
        :title="$t('debt_tasks.add')"
        @ok="handleStore"
        :ok-title="$t('buttons.ok')"
        :cancel-title="$t('buttons.cancel')"
        @ok-disabled="isProcessing"
        >
          <div class="form-group">
              <label for="users" class="col-form-label">{{ $t('users.index') }}</label>
              <select id="users" class="form-control select2" v-model="debt_task.users" multiple :class="{'is-invalid': errors.users }" aria-describedby="usersHelp" >
                  <option v-for="user in adminListUsers" :value="user.id" :key="user.id">
                    {{ user.lastname }} {{ user.firstname }}
                  </option>
              </select>
              <small id="usersHelp" class="form-text text-muted">{{ $t('hints.multiple_users') }}</small>
              <div class="custom-control custom-checkbox my-1 mr-sm-2">
                <input type="checkbox" class="custom-control-input" v-model="select_all_users" id="selectallusers" >
                <label class="custom-control-label" for="selectallusers" data-toggle="tooltip" data-placement="top" title="Выделить все">Выделить все</label>
              </div>
              <span v-if="errors.users" class="invalid-feedback">
                  <strong>{{ errors.users ? errors.users[0] : '' }}</strong>
              </span>
          </div>
          <div class="form-group row">
              <div class="col-md-6">
                <label for="statuses" class="col-form-label">{{ $t('options.statuses') }}</label>
                <select id="statuses" class="form-control" v-model="debt_task.statuses" multiple :class="{'is-invalid': errors.statuses }" aria-describedby="statusesHelp">
                    <option v-for="status in adminListDebtStatuses" :value="status.id" :key="status.id">
                        {{ status.name }}
                    </option>
                </select>
                <small id="statusesHelp" class="form-text text-muted">{{ $t('hints.multiple_statuses') }}</small>
                <div class="custom-control custom-checkbox my-1 mr-sm-2">
                  <input type="checkbox" class="custom-control-input" v-model="select_all_status" id="selectallfields" >
                  <label class="custom-control-label" for="selectallfields" data-toggle="tooltip" data-placement="top" title="Выделить все">Выделить все</label>
                </div>
                <span v-if="errors.statuses" class="invalid-feedback">
                    <strong>{{ errors.statuses ? errors.statuses[0] : '' }}</strong>
                </span>
              </div>

              <div class="col-md-6">
                <label for="contragents" class="col-form-label">{{ $t('contragents.index') }}</label>
                <select id="contragents" class="form-control" v-model="debt_task.contragents" multiple :class="{'is-invalid': errors.contragents }" aria-describedby="contragentsHelp">
                    <option v-for="contragent in adminListContragents" :value="contragent.id" :key="contragent.id">
                        {{ contragent.name }}
                    </option>
                </select>
                <small id="contragentsHelp" class="form-text text-muted">{{ $t('hints.multiple_contragents') }}</small>
                <div class="custom-control custom-checkbox my-1 mr-sm-2">
                  <input type="checkbox" class="custom-control-input" v-model="select_all_contragents" id="selectAllContragents" >
                  <label class="custom-control-label" for="selectAllContragents" data-toggle="tooltip" data-placement="top" title="Выделить все">Выделить все</label>
                </div>
                <span v-if="errors.contragents" class="invalid-feedback">
                    <strong>{{ errors.contragents ? errors.contragents[0] : '' }}</strong>
                </span>
              </div>
          </div>
          <div class="form-group">
              <label for="registry_date" class="col-form-label">{{ $t('debts.registry_date') }}</label>
              <select id="registry_date" class="form-control" v-model="debt_task.registry_date" :class="{'is-invalid': errors.registry_date }">
                  <option v-for="registry_date in adminListRegistryDates" :value="registry_date.registry_date" :key="registry_date.registry_date">
                      {{ registry_date.registry_date }}
                  </option>
              </select>
          </div>
          <div class="form-group row">
            <div class="col-md-6 col-12">
              <label for="startdate" class="col-form-label">{{ $t('debt_tasks.start_date') }}</label>
              <input id="startdate" type="datetime-local" class="form-control" v-model="debt_task.start_date" :class="{'is-invalid': errors.start_date }" :placeholder="$t('debt_tasks.start_date')">
              <span v-if="errors.start_date" class="invalid-feedback">
                  <strong>{{ errors.start_date ? errors.start_date[0] : '' }}</strong>
              </span>
            </div>
            <div class="col-md-6 col-12">
              <label for="enddate" class="col-form-label">{{ $t('debt_tasks.end_date') }} {{debt_task.end_date}}</label>
              <input id="enddate" type="datetime-local" class="form-control" v-model="debt_task.end_date"  :class="{'is-invalid': errors.end_date }" :placeholder="$t('debt_tasks.end_date')">
              <span v-if="errors.end_date" class="invalid-feedback">
                  <strong>{{ errors.end_date ? errors.end_date[0] : '' }}</strong>
              </span>
            </div>
          </div>
      </b-modal>

      <b-modal
        id="updatedebt_task"
        size="lg"
        :title="$t('debt_tasks.edit')"
        ref="modalUpdateDebtTask"
        @ok="handleUpdate"
        @shown="fetchDebtTasks"
        :ok-title="$t('buttons.save')"
        :cancel-title="$t('buttons.cancel')"
        >
          <div class="form-group">
              <label for="update_users" class="col-form-label">{{ $t('users.user') }}</label>
              <select id="update_users" class="form-control" v-model="update_debt_task.user_id" :class="{'is-invalid': update_errors.user_id }" >
                  <option v-for="user in adminListUsers" :value="user.id" :key="user.id">
                    {{ user.lastname }} {{ user.firstname }}
                  </option>
              </select>
              <span v-if="update_errors.user_id" class="invalid-feedback">
                  <strong>{{ update_errors.user_id ? update_errors.user_id[0] : '' }}</strong>
              </span>
          </div>
          <div class="form-group row">
              <div class="col-md-6">
                <label for="update_statuses" class="col-form-label">{{ $t('options.statuses') }}</label>
                <select
                  id="update_statuses"
                  class="form-control"
                  v-model="update_debt_task.selectedStatuses"
                  multiple
                  :class="{'is-invalid': update_errors.statuses }"
                  aria-describedby="updateStatusesHelp"
                  >
                    <option v-for="status in adminListDebtStatuses" :value="status.id" :key="status.id">
                        {{ status.name }}
                    </option>
                </select>
                <small id="updateStatusesHelp" class="form-text text-muted">{{ $t('hints.multiple_statuses') }}</small>
                <span v-if="update_errors.statuses" class="invalid-feedback">
                    <strong>{{ update_errors.statuses ? update_errors.statuses[0] : '' }}</strong>
                </span>
              </div>
              <div class="col-md-6">
                <label for="updatecontragents" class="col-form-label">{{ $t('contragents.index') }}</label>
                <select
                  id="updatecontragents"
                  class="form-control"
                  v-model="update_debt_task.selectedContragents"
                  multiple
                  :class="{'is-invalid': update_errors.contragents }"
                  aria-describedby="updatecontragentsHelp"
                  >
                    <option v-for="contragent in adminListContragents" :value="contragent.id" :key="contragent.id">
                      {{ contragent.name }}
                    </option>
                </select>
                <small id="updatecontragentsHelp" class="form-text text-muted">{{ $t('hints.multiple_contragents') }}</small>
                <span v-if="errors.contragents" class="invalid-feedback">
                    <strong>{{ errors.contragents ? errors.contragents[0] : '' }}</strong>
                </span>
              </div>
          </div>
          <div class="form-group">
              <label for="updateregistry_date" class="col-form-label">{{ $t('debts.registry_date') }}</label>
              <select id="updateregistry_date" class="form-control" v-model="update_debt_task.registry_date" :class="{'is-invalid': update_errors.registry_date }">
                  <option v-for="registry_date in adminListRegistryDates" :value="registry_date.registry_date" :key="registry_date.registry_date">
                      {{ registry_date.registry_date }}
                  </option>
              </select>
          </div>
          <div class="form-group row">
              <div class="col-md-6 col-12">
                  <label for="updatestartdate" class="col-form-label">{{ $t('debt_tasks.start_date') }}</label>
                  <input
                    id="updatestartdate"
                    type="datetime-local"
                    class="form-control"
                    v-model="update_debt_task.start_date"
                    :class="{'is-invalid': update_errors.start_date }"
                    :placeholder="$t('debt_tasks.start_date')"
                    >
                  <span v-if="update_errors.start_date" class="invalid-feedback">
                    <strong>{{ update_errors.start_date ? update_errors.start_date[0] : '' }}</strong>
                  </span>
              </div>
              <div class="col-md-6 col-12">
                  <label for="updateenddate" class="col-form-label">{{ $t('debt_tasks.end_date') }}</label>
                  <input
                    id="updateenddate"
                    type="datetime-local"
                    class="form-control"
                    v-model="update_debt_task.end_date"
                    :class="{'is-invalid': update_errors.end_date }"
                    :placeholder="$t('debt_tasks.end_date')"
                    >
                  <span v-if="update_errors.end_date" class="invalid-feedback">
                    <strong>{{ update_errors.end_date ? update_errors.end_date[0] : '' }}</strong>
                  </span>
              </div>
          </div>
      </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';

export default {
  data() {
    return {
      debt_tasks: [],
      debt_task: {
        users: [],
        statuses: [],
        contragents: [],
        registry_date: '',
        start_date: '',
        end_date: '',
      },
      users: [],
      select_all_users: false,
      select_all_status: false,
      select_all_contragents: false,
      debt_statuses: [],
      errors: {},
      update_errors: {},
      update_debt_task: {
        user_id: '',
        selectedStatuses: [],
        selectedContragents: [],
        start_date: '',
        end_date: '',
      },
      isProcessing: false,
      loadDebtTasks: false,
      pagination: {
        current_page: 1,
      },
    };
  },
  computed: {
    ...mapGetters([
      'adminListUsers',
      'adminListContragents',
      'adminListDebtStatuses',
      'adminListRegistryDates',
    ]),
  },
  created() {
    this.fetchDebtTasks();
    this.GET_ADMIN_LIST_DEBT_STATUSES();
    this.GET_ADMIN_LIST_CONTRAGENTS();
    this.GET_ADMIN_LIST_REGISTRY_DATES();
    this.GET_ADMIN_LIST_USERS();
  },
  methods: {
    ...mapActions([
      'GET_ADMIN_LIST_USERS',
      'GET_ADMIN_LIST_CONTRAGENTS',
      'GET_ADMIN_LIST_DEBT_STATUSES',
      'GET_ADMIN_LIST_REGISTRY_DATES',
    ]),

    fetchDebtTasks() {
      this.loadDebtTasks = true;
      const params = { page: this.pagination.current_page };
      window.axios.get('/admin/debt-tasks', { params })
        .then((res) => {
          this.debt_tasks = res.data.debt_tasks.data;
          this.pagination = this.laraPaginate(res.data.debt_tasks);
          this.loadDebtTasks = false;
        })
        .finally(() => {
          this.loadDebtTasks = false;
        });
    },
    clearStoreModal() {
      this.debt_task = {
        users: [],
        statuses: [],
        start_date: '',
        end_date: '',
      };
    },

    clearUpdateModal() {
      this.update_debt_task = {
        user_id: '',
        selectedStatuses: [],
        selectedContragents: [],
        start_date: '',
        end_date: '',
      };
    },

    initUpdate(index) {
      this.update_errors = {};
      this.update_debt_task = this.debt_tasks[index];
      this.update_debt_task.start_date = moment(this.debt_tasks[index].start_date).format('YYYY-MM-DDTHH:mm');
      this.update_debt_task.end_date = moment(this.debt_tasks[index].end_date).format('YYYY-MM-DDTHH:mm');

      if (this.update_debt_task.statuses) {
        this.update_debt_task.selectedStatuses = Object.keys(this.update_debt_task.statuses).map(i => this.update_debt_task.statuses[i].id);
      }
      if (this.update_debt_task.contragents) {
        this.update_debt_task.selectedContragents = Object.keys(this.update_debt_task.contragents).map(i => this.update_debt_task.contragents[i].id);
      }

      this.$refs.modalUpdateDebtTask.show();
    },

    handleStore(evt) {
      evt.preventDefault();
      this.storeDebTask();
    },

    handleUpdate(evt) {
      evt.preventDefault();
      this.updateDebTask();
    },

    handleDelete(id) {
      window.Swal.fire({
        title: this.$t('alerts.are_you_sure'),
        text: this.$t('alerts.want_to_delete'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('alerts.delete_it'),
        cancelButtonText: this.$t('field.cancel'),
      }).then((result) => {
        if (result.value) {
          this.deleteDebTask(id);
        }
      });
    },

    storeDebTask() {
      this.isProcessing = true;
      window.axios.post('/admin/debt-tasks', this.debt_task)
        .then((res) => {
          this.$refs.addDebtTask.hide();
          window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
          this.clearStoreModal();
          this.fetchDebtTasks();
        })
        .catch((err) => {
          this.errors = this.laravelValidation(err);
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },

    updateDebTask() {
      this.isProcessing = true;
      window.axios.put(`/admin/debt-tasks/${this.update_debt_task.id}`, this.update_debt_task)
        .then((res) => {
          if (res.status === 200) {
            this.$refs.modalUpdateDebtTask.hide();
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.clearUpdateModal();
            this.fetchDebtTasks();
          }
        })
        .catch((err) => {
          this.update_errors = this.laravelValidation(err);
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },

    deleteDebTask(id) {
      this.isProcessing = true;
      window.axios.delete(`/admin/debt-tasks/${id}`)
        .then((res) => {
          if (res.status === 204) {
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.fetchDebtTasks();
          }
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
  },
  watch: {
    select_all_status(value) {
      const vm = this;
      if (value) {
        this.adminListDebtStatuses.forEach((status, index) => {
          vm.debt_task.statuses[index] = status.id;
        });
      } else {
        this.debt_task.statuses = [];
      }
    },
    select_all_contragents(value) {
      const vm = this;
      if (value) {
        this.adminListContragents.forEach((contragent, index) => {
          vm.debt_task.contragents[index] = contragent.id;
        });
      } else {
        this.debt_task.contragents = [];
      }
    },
    select_all_users(value) {
      const vm = this;
      if (value) {
        this.adminListUsers.forEach((user, index) => {
          vm.debt_task.users[index] = user.id;
        });
      } else {
        this.debt_task.users = [];
      }
    },
  },
};
</script>
